module.exports = __webpack_public_path__ + "static/media/Thought-leaders-thumbnail.bc5fe1dc.jpg";